import auth from './routes/auth'
import eds from './routes/eds'
import notFound from './routes/notFound'
import clientAccess from './routes/clientAccess.js'
import administration from './routes/administration.js'
import operationRisk from './routes/operationRisk.js'
import audit from './routes/audit.js'
import task from './routes/task.js'
import documentAgreement from './routes/documentAgreement'
import sso from './routes/sso'

export default [
  ...auth,
  ...eds,
  ...clientAccess,
  ...operationRisk,
  ...audit,
  ...administration,
  ...task,
  ...sso,
  ...notFound,
  ...documentAgreement,
]
